import { ALL_CALCULATIONS } from "@suse-o11y/calculate-value-from-points";
import { z } from "zod";

import { ALL_PIE_CHART_TYPES } from "~/components/pie-chart/utils";
import type { PieChart as OpenApiPieChart } from "~/main/common/openapi";

import type { Settings } from "../../../components/widget-form/pie-chart/settings";
import { ALL_SORT_DIRECTIONS } from "../../../components/widget-form/sort/settings";
import { dashboardWidgetFormatSchema } from "../_dashboard-widget-format";

import { Legend } from "./_sub-schemas";

const schema = z
	.object({
		format: dashboardWidgetFormatSchema.optional().catch(undefined),

		calculation: z.enum(ALL_CALCULATIONS).optional().catch(undefined),

		sort: z.enum(ALL_SORT_DIRECTIONS).optional().catch(undefined),

		type: z.enum(ALL_PIE_CHART_TYPES).optional().catch(undefined),

		legend: Legend.schema.optional().catch(undefined),
	})
	.catch({});

type PieChart = z.infer<typeof schema>;

function fromSettings(settings: undefined | Settings): PieChart {
	return {
		calculation: settings?.calculation,
		sort: settings?.sort,
		type: settings?.type,
		legend: Legend.fromSettings(settings?.legend),

		format: {
			unit: settings?.unit,
			decimalPlaces: settings?.decimals,
		},
	};
}

function toSettings(spec: undefined | PieChart): Settings {
	return {
		unit: spec?.format?.unit,
		decimals: spec?.format?.decimalPlaces,
		calculation: spec?.calculation,
		sort: spec?.sort,
		type: spec?.type,
		legend: Legend.toSettings(spec?.legend),
	};
}

function openApiToSettings({ unit, decimals, calculation, sort, type }: OpenApiPieChart): Settings {
	return { unit, decimals, calculation, sort, type };
}

const PieChart = { schema, fromSettings, toSettings, openApiToSettings };

export { PieChart };
